import { colors } from '../constants';

const COUNTER_NAME = 'invoiceLineItem';

/**
 * Line numbers come from a CSS counter rather than the array index, so a row
 * never receives its position as a prop. Without this, prepending or removing a
 * line changes the index of every line after it and re-renders the whole list.
 *
 * Apply `LINE_ITEMS_CONTAINER_SX` to the element wrapping the rows and
 * `LINE_NUMBER_SX` to the (empty) element that shows "Item N" in each row.
 */
export const LINE_ITEMS_CONTAINER_SX = { counterReset: COUNTER_NAME };

export const LINE_NUMBER_SX = {
  fontWeight: 700,
  color: colors.gray600,
  '&::before': {
    counterIncrement: COUNTER_NAME,
    content: `"Item " counter(${COUNTER_NAME})`,
  },
};

// Bare number for a table row, where the column already says what it counts.
export const LINE_INDEX_SX = {
  color: colors.gray500,
  '&::before': {
    counterIncrement: COUNTER_NAME,
    content: `counter(${COUNTER_NAME})`,
  },
};
